'use strict';

/**
 * Chart Element Constants
 *
 * @readonly
 */
var ChartElementConstants = {
  AXIS: {
    /**
     * Axis' mode
     * @enum {string}
     */
    MODE: {
      LEFT: 'left',
      RIGHT: 'right',
      TOP: 'top',
      BOTTOM: 'bottom'
    },
    /**
     * Text skew definitions
     * @enum {object}
     */
    SKEW: {
      DEG_90: {
        x: -10,
        y: 0,
        dy: '0.35em',
        transform: 'rotate(-90)'
      },
      DEG_45: {
        x: -5,
        y: 0,
        dy: '1.35em',
        transform: 'rotate(-45)'
      },
      DEG_30: {
        x: -3,
        y: 0,
        dy: '1.15em',
        transform: 'rotate(-30)'
      },
      DEG_40_A: {
        x: -3,
        y: 0,
        dy: '1.15em',
        transform: 'rotate(-40)'
      },
      DEG_40_B: {
        x: 25,
        y: 20,
        dy: '1.15em',
        transform: 'rotate(-40)'
      },
      DEG_30_A: {
        x: 25,
        y: 20,
        dy: '1.15em',
        transform: 'rotate(-30)'
      },
      DEG_30_B: {
        x: 5,
        y: 5,
        dy: '1.15em',
        transform: 'rotate(-30)'
      }
    }
  },
  VERTICAL_LINE: {
    SIZE: {
      CONTAINER: 'CONTAINER'
    }
  },
  LEGEND_ITEM: {
    /**
     * Legend item's style
     * @enum {string}
     */
    STYLE: {
      LINE: 'line',
      CIRCLE: 'circle',
      LINE_WITH_CIRCLE: 'line-with-circle'
    }
  },
  DIRECTION: {
    RTL: 'right-to-left',
    LTR: 'left-to-right'
  },
  PIN_LINE: {
    CURRENT: 'Curr'
  },
  SIMPLE_LINE: {
    ALIGN_LEFT: 'left',
    ALIGN_CENTER: 'center'
  }
};
module.exports = ChartElementConstants;